module.exports = __webpack_public_path__ + "images/Env1-a16257da3476a7bdeb305de6d81ced6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/Env1.jpg
// module id = 37
// module chunks = 0